import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import { CustomListItemStyle } from '@cims-online/shared'
import CIMSSelect from 'components/CIMSSelect'
import { InitialValue } from 'components/CIMSFormItem/types'
import { useOptions } from 'components/CIMSSelect/hooks/useOptions'

const StyleFormItem: React.FC<InitialValue<string>> = ({ initialValue }) => {
  const options = useOptions({
    items: CustomListItemStyle.values,
    value: 'id',
    label: 'label',
    sort: 'name',
  })
  return (
    <CIMSFormItem
      label="Style"
      help={HelpMessage.Administration.CustomFields.Style}
      name="styleId"
      requiredMessage="Please select a style"
      initialValue={initialValue ?? CustomListItemStyle.Multiple.id}
    >
      <CIMSSelect simple options={options} />
    </CIMSFormItem>
  )
}

export default StyleFormItem
